import { motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import checkAnimation from '@/assets/lottie/check.json';

const LottieAnimation = dynamic(() => import('@/components/LottieAnimation'), {
  ssr: false,
});

export default function SubmissionModal({
  setSubmissionModalIsOpen,
  primarycolor,
  currentReward,
  profileInfo,
  missionTypeName,
  onClose,
}) {
  const isReferenceOptIn = missionTypeName === 'Reference Opt-In';

  const getTitle = () => {
    if (isReferenceOptIn) return 'Thank You!';
    return 'Submission Received!';
  };

  const getMessage = () => {
    if (isReferenceOptIn) {
      return "Thanks for signing up to be a reference! If we have a good match to a customer we think would benefit from hearing from you, we'll reach out!";
    }
    return 'Your submission is now pending review.';
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={() => {
        setSubmissionModalIsOpen(false);
        onClose?.();
      }}
      className="bg-slate-900/20 backdrop-blur-sm p-4 fixed inset-0 z-50 grid place-items-center overflow-y-scroll cursor-pointer"
    >
      <motion.div
        initial={{ scale: 0, rotate: '12.5deg' }}
        animate={{ scale: 1, rotate: '0deg' }}
        exit={{ scale: 0, rotate: '0deg' }}
        onClick={(e) => e.stopPropagation()}
        className="bg-[#F5F5F5] text-white pl-6 pb-6 pr-6 pt-16 rounded-lg w-full max-w-lg shadow-xl cursor-default relative"
      >
        <div className="relative z-10 ">
          <div className="flex absolute items-center justify-center w-full -mt-52">
            <div>
              <LottieAnimation
                animationData={checkAnimation}
                style={{
                  height: '200px',
                  width: '200px',
                  display: 'flex',
                }}
                loop="false"
              />
            </div>
          </div>
          <div style={{ borderColor: primarycolor }} className="flex flex-col mt-16 border-l-3">
            <h3 className="text-2xl text-gray-800 font-poppins font-semibold text-left  ml-2">{getTitle()}</h3>{' '}
            <p className="text-left mt-1 font-poppins font-light text-gray-800 ml-2">{getMessage()}</p>
          </div>
          <div className="flex gap-2 mt-12">
            <button
              type="button"
              style={{
                backgroundColor: primarycolor,
              }}
              className={`text-white hover:opacity-90 transition-opacity font-semibold w-full py-2 rounded-[7px]`}
              disabled={currentReward && Number(currentReward?.pointsRequired || 0) > (profileInfo?.pointsAmount || 0)}
              onClick={() => {
                setSubmissionModalIsOpen(false);
                onClose?.();
              }}
            >
              OK
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}

SubmissionModal.propTypes = {
  setSubmissionModalIsOpen: PropTypes.func,
  animationData: PropTypes.object,
  primarycolor: PropTypes.string,
  currentReward: PropTypes.object,
  profileInfo: PropTypes.array,
  missionTypeName: PropTypes.string,
  onClose: PropTypes.func,
};
